import React, { useState, createContext, useContext } from "react";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom";
//import { Post } from "../services/api_service";
//import axios from "axios";
import { useDispatch } from "react-redux";
import { loggedIn } from "../features/professional";
import {getApiUrl} from "../services/api_service";

const AuthContext = createContext();

//export default AuthContext;

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  let [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem("authTokens")
      ? JSON.parse(localStorage.getItem("authTokens"))
      : null
  );
  let [user, setUser] = useState(() =>
    localStorage.getItem("authTokens")
      ? jwt_decode(localStorage.getItem("authTokens"))
      : null
  );

  let [loginLoading, setLoginLoading] = useState(false);
  let [loginStatus, setLoginStatus] = useState(200);
  let setAuthData = (data) => {
    setAuthTokens(data);
      setUser(jwt_decode(data.accessToken));
      setLoginStatus(200);
      localStorage.setItem("authTokens", JSON.stringify(data));
      dispatch(loggedIn(jwt_decode(data.accessToken)));
  }

  const history = useHistory();

  let loginUser = async (e) => {
    setLoginLoading(true);
    let response = await fetch(
      getApiUrl() + process.env.REACT_APP_GET_AUTH,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: e.email,
          password: e.password,
        }),
      }
    );

    let data = await response.json();
    
    if (response.status === 200) {
      setAuthTokens(data);
      setUser(jwt_decode(data.accessToken));
      setLoginStatus(200);
      localStorage.setItem("authTokens", JSON.stringify(data));
      dispatch(loggedIn(jwt_decode(data.accessToken)));
      history.push("/");
    } else {
      setLoginStatus(401);
    }
    setLoginLoading(false);
  };

  let logoutUser = () => {
    setAuthTokens(null);
    setUser(null);
    localStorage.removeItem("authTokens");
    localStorage.removeItem("currentpatient");
    localStorage.clear();
    dispatch(loggedIn(""));
    history.push("/login");
  };

  let contextData = {
    user: user,
    loginLoading: loginLoading,
    loginStatus: loginStatus,
    loginUser: loginUser,
    logoutUser: logoutUser,
    setAuthData: setAuthData,
  };

  return (
    <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};